<template>
  <div>
    <WinnerContacts></WinnerContacts>
    <WinsCustomerInfo></WinsCustomerInfo>

    <!-- <h2 class="text-center colorblue">Реестр расчетов</h2> -->
    <CalcTable />
  </div>
</template>

<script>
import WinnerContacts from "./calcRegister/WinsWinnerContacts";
import WinsCustomerInfo from "./calcRegister/WinsCustomerInfo";
import CalcTable from './MyCalculationsTable'
export default {
  components: {
    WinnerContacts,
    WinsCustomerInfo,
    CalcTable,
  },
  mounted(){
    this.setTitle('Реестр расчетов')
  }

};
</script>

<style lang="scss">

</style>
